import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { Route, Routes } from "react-router-dom"
import { UsersContext } from "./context"
import { UsersListing } from "./containers/listing"
import { ERoutes } from "../../utils/url"

export default function Users({ setAccount }: any): any {
    return (
        <ContentSectionContainer className="suppressionListContainer">
            <UsersContext.Provider value={{}}>
                <Routes>
                    <Route index path={fetchRoute({ route: ERoutes.users })} element={<UsersListing setAccount={setAccount} />} />
                    <Route index path={"/"} element={<UsersListing setAccount={setAccount} />} />
                </Routes>
            </UsersContext.Provider>
        </ContentSectionContainer>
    )
}